import { IMetadata } from '@gositeinc/ui'
import { NextSeo, NextSeoProps } from 'next-seo'

import { getOpenGraphMediaData } from 'src/utils'

const Seo = ({ metadata, ...props }: SeoProps): JSX.Element | null => {
  // Prevent errors if no metadata was set
  if (metadata == null) return null

  const {
    canonical,
    metaDescription,
    metaTitle,
    twitterCardType,
    twitterUsername,
    shareImage
  } = metadata

  return (
    <NextSeo
      title={metaTitle}
      description={metaDescription}
      openGraph={{
        // Title and description are mandatory
        title: metaTitle,
        description: metaDescription,
        // Only include OG image if we have it
        // Careful: if you disable image optimization in Strapi, this will break
        ...(shareImage?.formats != null && getOpenGraphMediaData(metadata))
      }}
      // Only included Twitter data if we have it
      twitter={{
        ...(twitterCardType != null && twitterCardType !== '' && { cardType: twitterCardType }),
        // Handle is the twitter username of the content creator
        ...(twitterUsername != null && twitterUsername !== '' && { handle: twitterUsername })
      }}
      canonical={canonical}
      {...props}
    />
  )
}

export interface SeoProps extends NextSeoProps {
  metadata?: IMetadata
}

export default Seo
